const prefix = 'LEAD';
export const FETCH_LEAD = Symbol(`${prefix}/FETCH_LEAD`);
export const ADD_LEAD = Symbol(`${prefix}/ADD_LEAD`);
export const UPDATE_LEAD = Symbol(`${prefix}/UPDATE_LEAD`);
export const DELETE_LEAD = Symbol(`${prefix}/DELETE_LEAD`);
export const DELETE_LEAD_SUCCESS = Symbol(`${prefix}/DELETE_LEAD_SUCCESS`);

export const DELETE_LEAD_CONTACT_DATA = Symbol(`${prefix}/DELETE_LEAD_CONTACT_DATA`);
export const SET_PRIMARY_CONTACT = Symbol(`${prefix}/SET_PRIMARY_CONTACT`);

export const DELETE_QUOTE = Symbol(`${prefix}/DELETE_QUOTE`);
export const DELETE_INVOICE = Symbol(`${prefix}/DELETE_INVOICE`);
export const DELETE_DOCUMENT = Symbol(`${prefix}/DELETE_DOCUMENT`);

// Activity log
export const GET_LEAD_COMMENTS = Symbol(`${prefix}/GET_LEAD_COMMENTS`);
export const ADD_LEAD_COMMENTS = Symbol(`${prefix}/ADD_LEAD_COMMENTS`);
export const CREATE_LEAD_COMMENT = Symbol(`${prefix}/CREATE_LEAD_COMMENT`);
export const UPDATE_LEAD_COMMENT = Symbol(`${prefix}/UPDATE_LEAD_COMMENT`);
export const DELETE_LEAD_COMMENT = Symbol(`${prefix}/DELETE_LEAD_COMMENT`);

// checklist
export const GET_CHECKLIST_ITEMS = Symbol(`${prefix}/GET_CHECKLIST_ITEMS`);
export const CREATE_CHECKLIST_FROM_TEMPLATE = Symbol(`${prefix}/CREATE_CHECKLIST_FROM_TEMPLATE`);
export const CREATE_CHECKLIST_ITEM = Symbol(`${prefix}/CREATE_CHECKLIST_ITEM`);
export const UPDATE_CHECKLIST_ITEM = Symbol(`${prefix}/UPDATE_CHECKLIST_ITEM`);
export const DELETE_CHECKLIST_ITEM = Symbol(`${prefix}/DELETE_CHECKLIST_ITEM`);
export const UPDATE_CHECKLIST_ITEM_STORE = Symbol(`${prefix}/UPDATE_CHECKLIST_ITEM_STORE`);
export const REMOVE_CHECKLIST_ITEM_STORE = Symbol(`${prefix}/REMOVE_CHECKLIST_ITEM_STORE`);
export const ADD_CHECKLIST_ASSIGNMENT = Symbol(`${prefix}/ADD_CHECKLIST_ASSIGNMENT`);
export const REMOVE_CHECKLIST_ASSIGNMENT = Symbol(`${prefix}/REMOVE_CHECKLIST_ASSIGNMENT`);
export const UPDATE_CHECKLIST_ASSIGNMENT_STORE = Symbol(`${prefix}/UPDATE_CHECKLIST_ASSIGNMENT_STORE`);
export const REMOVE_CHECKLIST_ASSIGNMENT_STORE = Symbol(`${prefix}/REMOVE_CHECKLIST_ASSIGNMENT_STORE`);
export const GET_CHECKLIST_COMMENTS = Symbol(`${prefix}/GET_CHECKLIST_COMMENTS`);
export const ADD_CHECKLIST_COMMENT = Symbol(`${prefix}/ADD_CHECKLIST_COMMENT`);
export const UPDATE_CHECKLIST_COMMENT = Symbol(`${prefix}/UPDATE_CHECKLIST_COMMENT`);
export const DELETE_CHECKLIST_COMMENT = Symbol(`${prefix}/DELETE_CHECKLIST_COMMENT`);
export const UPDATE_CHECKLIST_COMMENT_STORE = Symbol(`${prefix}/UPDATE_CHECKLIST_COMMENT_STORE`);
export const REMOVE_CHECKLIST_COMMENT_STORE = Symbol(`${prefix}/REMOVE_CHECKLIST_COMMENT_STORE`);
export const REORDER_CHECKLIST_ITEM = Symbol(`${prefix}/REORDER_CHECKLIST_ITEMS`);
export const RESORT_CHECKLIST_ITEMS_STORE = Symbol(`${prefix}/RESORT_CHECKLIST_ITEMS_STORE`);
export const GET_CHECKLIST_REMINDERS = Symbol(`${prefix}/GET_CHECKLIST_REMINDERS`);
export const CREATE_CHECKLIST_REMINDER = Symbol(`${prefix}/CREATE_CHECKLIST_REMINDER`);
export const UPDATE_CHECKLIST_REMINDER = Symbol(`${prefix}/UPDATE_CHECKLIST_REMINDER`);
export const DELETE_CHECKLIST_REMINDER = Symbol(`${prefix}/DELETE_CHECKLIST_REMINDER`);
export const SET_CHECKLIST_REMINDERS = Symbol(`${prefix}/SET_CHECKLIST_REMINDERS`);

// custom form fields
export const UPDATE_CUSTOM_FORM_FIELD_DATA = Symbol(`${prefix}/UPDATE_CUSTOM_FORM_FIELD_DATA`);
export const ADD_CUSTOM_FORM_FIELD_DATA = Symbol(`${prefix}/ADD_CUSTOM_FORM_FIELD_DATA`);
